import { Divider } from "components/atoms/Divider";
import Layout from "components/layout";
import { AppHeader } from "components/layout/Header";
import { ZodiacList } from "features/daily-holoscope/components/ZodiacList";
import { GetServerSidePropsContext, GetStaticProps } from "next";
import { NextSeo, NextSeoProps } from "next-seo";
import { ReactNode, useState } from "react";
import { Image } from "shared/components/atoms/Image";
import { ScrollMeasure } from "shared/components/atoms/ScrollMeasure";
import tw from "twin.macro";
import { MetaTag } from "utils/seo";
import getNextSeoProps from "utils/ssr/getNextSeoProps";

const fontCss = tw`font-hira-mincho font-semibold text-white tracking-normal`;

const HEADER_TRANSITION_POINT = 320;

interface Props {
  nextSeoProps: NextSeoProps;
}

const DailyHoloscopeList = ({ nextSeoProps }: Props) => {
  const [transparent, setTransparent] = useState(true);

  const onScroll = (
    _clientHeight: number,
    _innerHeight: number,
    scrollY: number
  ) => {
    if (transparent && scrollY >= HEADER_TRANSITION_POINT) {
      setTransparent(false);
    } else if (!transparent && scrollY < HEADER_TRANSITION_POINT) {
      setTransparent(true);
    }
  };

  return (
    <>
      <NextSeo {...nextSeoProps} />
      <ScrollMeasure onScroll={onScroll}>
        <div tw="relative flex-center">
          <Image
            src={`${process.env.NEXT_PUBLIC_CDN_V2}/decoration/large_asymmetry_rainbow.png`}
            width={376}
            height={323}
            layout="responsive"
            priority
            tw="w-full"
          />
          <div tw="absolute">
            <AppHeader transparent={transparent} />
            <div tw="pt-4 px-8">
              <div tw="text-sm" css={fontCss}>
                毎日占い
              </div>
              <h2 tw="mt-2" css={[fontCss, tw`text-[25px]`]}>
                {`TODAY'S HOROSCPOE`}
              </h2>
              <Divider tw="w-1/5" />
              <p tw="text-xs leading-5" css={fontCss}>
                日本最大級の占いプラットフォームMIRORが毎日お届け。
                総合運、恋愛運、金運、仕事運、さまざまなジャンルから今日のあなたの運勢を鑑定します。貴方に１日の指針と気付きを少しだけ。
              </p>
            </div>
          </div>
        </div>
        <ZodiacList tw="mt-[30px]" />
      </ScrollMeasure>
    </>
  );
};

DailyHoloscopeList.getLayout = (page: ReactNode) => {
  return (
    <Layout header={null} nav={null}>
      {page}
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async (
  ctx: GetServerSidePropsContext
) => {
  const nextSeoProps = getNextSeoProps(ctx, {
    title: MetaTag.dailyHoloscopesIndex.title(),
    description: MetaTag.dailyHoloscopesIndex.description(),
    keywords: MetaTag.dailyHoloscopesIndex.keywords(),
  });
  return {
    props: {
      nextSeoProps: nextSeoProps,
    },
  };
};

export default DailyHoloscopeList;
